<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">For booksellers everywhere: <br/>Your job is harder than it looks. <br/>Your influence is greater than you’ll ever know.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?bfe9ea36